import React from 'react';
import '../blocks/ModernBlocks.css';

const CaseStudiesBlock = ({ data }) => {
  return (
    <section className="case-studies-section" id="case-studies">
      <div className="case-studies-container">
        <div className="case-studies-header">
          <h2 className="case-studies-title">{data.title}</h2>
          <p className="case-studies-subtitle">{data.subtitle}</p>
        </div>
        <div className="case-studies-grid">
          {data.items.map((study, index) => (
            <div key={index} className="case-study-card">
              <div className="case-study-image">
                <img src={study.image} alt={study.title} />
                <div className="case-study-overlay">
                  <span className="case-study-subtitle">{study.subtitle}</span>
                </div>
              </div>
              <div className="case-study-content">
                <div className="case-study-header">
                  <h3 className="case-study-title">{study.title}</h3>
                </div>
                <p className="case-study-description">{study.description}</p>
                
                <div className="case-study-results">
                  <h4>Key Results:</h4>
                  <ul>
                    {study.metrics.map((metric, metricIndex) => (
                      <li key={metricIndex}>{metric}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CaseStudiesBlock; 